import { render, staticRenderFns } from "./mdm-form-report-insert-row.vue?vue&type=template&id=3b6ce8d4&scoped=true"
import script from "./mdm-form-report-insert-row.vue?vue&type=script&lang=js"
export * from "./mdm-form-report-insert-row.vue?vue&type=script&lang=js"
import style0 from "./mdm-form-report-insert-row.vue?vue&type=style&index=0&id=3b6ce8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6ce8d4",
  null
  
)

export default component.exports